module.exports = __webpack_public_path__ + "img/p5.eec6e5ab.png";